export class Captcha {
    code: string;
    image: string;
    constructor() {
        this.code = "";
        this.image = "";
    }
}